import React, { useState } from 'react';
import { Button } from '../index';
import classNames from 'classnames';
import './select-text-image.less';

import DeleteIcon from 'assests/icons/delete.icon';
import { message } from 'antd';

const SelectTextImage = (props) => {
  const [selectedImageSrc, setSelectedImageSrc] = useState('');

  const reader = new FileReader();

  function previewFile(e) {
    let fileList = e.target.files;
    let file = fileList[0];
    let extension = file.name.split('.').pop().toLowerCase(); // assuming that this file has any extension
    if (props.allowExtensions.includes(extension))
    {
      props.onChange(e);
      const file = document.querySelector('input[type=file]').files[0];

      reader.addEventListener(
        'load',
        function () {
          setSelectedImageSrc(reader.result);
        },
        false
      );

      if (file) {
        reader.readAsDataURL(file);
      }
    }
    else
    {
      message.error(props.errorMessage);
    }
  }

  function removePreviewFile() {
    document.querySelector('input[type=file]').value = '';
    props.onRemoveFile();
  }

  return (
    <div className="select-text-image">
      <div className="select-text-image__content">
        <figure className={classNames({ block: selectedImageSrc })}>
          <img className="selected-image" src={selectedImageSrc} />
          <div
            onClick={() => {
              setSelectedImageSrc('');
              removePreviewFile();
            }}
          >
            <DeleteIcon />
          </div>
        </figure>

        {selectedImageSrc ? null : (
          <>
            <strong>Görsel Yükle</strong>
            <span>
              Desteklenen dosya tipleri: jpg, jpeg, png, gif, mp3, 3gp, mp4
            </span>
            <span>Maksimum dosya boyutu: 1 MB </span>
          </>
        )}
      </div>
      <div className="select-text-image__action">
        <Button type="ghost">
          {selectedImageSrc ? 'Değiştir...' : 'Seç...'}
        </Button>
        <input type="file" name="file" onChange={previewFile} />
      </div>
    </div>
  );
};

export default SelectTextImage;
